import React, { useState } from 'react';

import { TextType } from 'src/client/types/Text';
import { PageRecipient } from 'src/commons/types';

import * as stylesheet from './styles';

type Props = {
  pageRecipient: PageRecipient;
  pageRecipientLogoReplacementTextType: TextType;
  styles?: any;
};

function RecipientLogo(props: Props) {
  const { pageRecipient, pageRecipientLogoReplacementTextType, styles } = props;

  const S = styles ?? stylesheet;

  const [isLogoBroken, setIsLogoBroken] = useState(false);

  function handleImageError() {
    setIsLogoBroken(true);
  }

  return isLogoBroken ? (
    <S.RecipientLogoReplacementContainer>
      <S.RecipientLogoReplacement type={pageRecipientLogoReplacementTextType}>
        {pageRecipient.recipientName}
      </S.RecipientLogoReplacement>
    </S.RecipientLogoReplacementContainer>
  ) : (
    <S.RecipientLogo
      src={pageRecipient.imagePath ?? ''}
      onError={handleImageError}
    />
  );
}

export default RecipientLogo;
